export default "__VITE_ASSET__DW$TFFi2__"